import {combineReducers} from '@reduxjs/toolkit';
import brandGuidelinesReducer from './brandGuidelines/brandGuidelines.slice';
import brandAssetsReducer from './brandAssets/brandAssets.slice';
import brandPersonasReducer from './brandPersonas/brandPersonas.slice';

const brandGuidelinesPageReducer = combineReducers({
  brandGuidelines: brandGuidelinesReducer,
  brandAssets: brandAssetsReducer,
  brandPersonas: brandPersonasReducer,
  // Future brand guidelines related settings can be added here:
  // brandFonts: brandFontsReducer,
  // brandTemplates: brandTemplatesReducer,
  // etc.
});

export default brandGuidelinesPageReducer; 